// src/hooks/useCart.js
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCart, addToCart, updateCartItem, removeFromCart, clearCart } from '../store/cartSlice.js';

// ============================================================
// 🔑 ПОЧЕМУ useCallback, А НЕ ПРОСТЫЕ СТРЕЛОЧНЫЕ ФУНКЦИИ.
//
//    `const handleGetCart = () => dispatch(getCart())` создаётся
//    ЗАНОВО на каждом рендере. Как только такую функцию кладут в
//    зависимости эффекта —
//        useEffect(() => { getCart(); }, [getCart]);
//    — получается бесконечный цикл: эффект → запрос → стор → рендер
//    → новая ссылка → эффект снова.
//
//    ⚠️ Ловушка в том, что цикл виден НЕ сразу: пока функцию не
//       положили в зависимости, всё работает. Ошибка проявляется
//       позже и в другом файле.
//
//    useCallback закрепляет ссылку (`dispatch` стабилен) — функция
//    создаётся один раз и безопасна в зависимостях.
// ============================================================
export const useCart = () => {
  const dispatch = useDispatch();
  const { items, total, count, isLoading, isLoaded, error } = useSelector((state) => state.cart);

  const handleGetCart = useCallback(() => dispatch(getCart()), [dispatch]);
  const handleAddToCart = useCallback((data) => dispatch(addToCart(data)), [dispatch]);
  const handleUpdateCartItem = useCallback(
    (id, data) => dispatch(updateCartItem({ id, data })),
    [dispatch]
  );
  const handleRemoveFromCart = useCallback((id) => dispatch(removeFromCart(id)), [dispatch]);
  const handleClearCart = useCallback(() => dispatch(clearCart()), [dispatch]);

  return {
    items,
    total,
    count,
    isLoading,
    isLoaded,
    error,
    getCart: handleGetCart,
    addToCart: handleAddToCart,
    updateCartItem: handleUpdateCartItem,
    removeFromCart: handleRemoveFromCart,
    clearCart: handleClearCart,
  };
};
